/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import RefreshIcon from '@mui/icons-material/Refresh';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { IconButton, Link as MuiLink, Stack, Typography } from '@mui/material';
import { formatDateLocal, type RecentComponentRecord } from '@poweralpha/common';
import RecordList from '../../react-components/RecordList';
import { InfoPill } from '../../react-components/text';
import Widget from '../../react-components/Widget';
import { useRecentComponentsQuery } from '../api';

const getRow = (component: RecentComponentRecord) => (
  <Stack
    spacing={0.5}
    sx={{
      width: '100%',
    }}
  >
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <MuiLink
        component="span"
        underline="always"
        sx={{ fontSize: 13, fontWeight: 600, lineHeight: 1.2, color: 'primary.main' }}
        noWrap
      >
        {component.name || component.id}
      </MuiLink>
      <InfoPill label={component.component_type} />
    </Stack>
    <Stack
      direction="row"
      spacing={0.75}
      sx={{
        alignItems: 'center',
      }}
    >
      <ScheduleIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
      <Typography
        variant="caption"
        noWrap
        sx={{
          color: 'text.secondary',
        }}
      >
        {formatDateLocal(component.created_at)}
      </Typography>
    </Stack>
  </Stack>
);

function RecentDbComponents() {
  const recentComponentsQuery = useRecentComponentsQuery({ limit: 10 });

  return (
    <Widget
      title="My recently created components"
      actions={
        <IconButton
          loading={recentComponentsQuery.isRefetching}
          size="small"
          onClick={() => recentComponentsQuery.refetch()}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      }
      redirectPath="/db"
      titleLink
    >
      <RecordList
        label="component"
        queryResult={recentComponentsQuery}
        getRow={getRow}
        getLink={(component) => component.path}
        idKey="key"
      />
    </Widget>
  );
}

export default RecentDbComponents;
